import api from '@/store/api/customer/subaccount'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    subaccount: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        subaccount: state => state.subaccount
    },
    actions: {
        showSubaccount: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showSubaccount(data)
                commit(mutationTypes.SET_SUBACCOUNT, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        inviteUser: async ({dispatch}, data) => {
            try {
                const response = await api.inviteUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        inviteLegacy: async ({dispatch}, data) => {
            try {
                const response = await api.inviteLegacy(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        sendInvite: async ({dispatch}, data) => {
            try {
                const response = await api.sendInvite(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        revokeInvite: async ({dispatch}, data) => {
            try {
                const response = await api.revokeInvite(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        deactivateUser: async ({dispatch}, data) => {
            try {
                const response = await api.deactivateUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        deleteUser: async ({dispatch}, data) => {
            try {
                const response = await api.deleteUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        forcePasswordChange: async ({dispatch}, data) => {
            try {
                const response = await api.forcePasswordChange(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        sendPasswordReset: async ({dispatch}, data) => {
            try {
                const response = await api.sendPasswordReset(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        remove2Fa: async ({dispatch}, data) => {
            try {
                const response = await api.remove2Fa(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSubaccount: async ({commit}) => commit(mutationTypes.RESET_SUBACCOUNT)
    },
    mutations: {
        [mutationTypes.SET_SUBACCOUNT]: (state, data) => state.subaccount = data,
        [mutationTypes.RESET_SUBACCOUNT]: (state) => Object.assign(state, initialState())
    }
}
